export default __webpack_public_path__ + "static/media/usa.97ea9859.svg";